

































































































// @ is an alias to /src
import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Buttons from "@/components/Buttons.vue";
import Formulario from "@/components/Formulario.vue";
import info from "@/info";

@Component({
  components: {
    Buttons,
    Navbar,
    Footer,
    Formulario,
  },
})
export default class Promociones extends Vue {
  public autoName: string = "";
  public aIndex: object = {};

  openMenuForm(autoN: string) {
    this.aIndex == null
      ? this.aIndex
      : (this.aIndex = info.home.headerSlider[0]);
    this.autoName = autoN;
    for (let i in info.home.headerSlider) {
      if (info.home.headerSlider[i].name === this.autoName) {
        this.aIndex = info.home.headerSlider[i];
      }
    }
    const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
    const idDiv = document.getElementById("uk-navbar-dropdown-id");

    if (idDivModel) {
      idDivModel.style.display = "none";
    }
    if (idDiv) {
      idDiv.style.display = "none";
    }

    let curtainForm = document.getElementById("curtain-formP");
    let menuForm = document.getElementById("menu-formP");

    if (curtainForm) {
      curtainForm.style.display = "block";
    }
    menuForm?.classList.remove("disable-menu-form");
    menuForm?.classList.add("open-menu-form");
  }
  closeMenuForm() {
    let curtainForm = document.getElementById("curtain-formP");
    let menuForm = document.getElementById("menu-formP");

    if (curtainForm) {
      curtainForm.style.display = "none";
    }
    menuForm?.classList.remove("open-menu-form");
    menuForm?.classList.add("disable-menu-form");
  }
  scrollState(state: string) {
    const elem = document.getElementById("scrollBlock");
    elem!.style.overflow = state;
  }
}
